<script>
    import {Input, FileSelect, Select, Button, Textarea} from '../../components/ui';

  export let model;

</script>

<div>
  <div>
    <h2>Title</h2>
    <div>
    <Textarea bind:model={model.title} />
    </div>
  </div>
    <div class="mt-8">
    <h2>Description</h2>
    <div>
    <Textarea bind:model={model.description} />
    </div>
  </div>
</div>